import { httpGet, httpPost, httpPut, httpDelete } from '@/utils/request';

export const socket_connect = () => httpPost('/websocket/connect');

// socket链接 - 不用登录
export const socket_connect_without_login = () => httpPost('/websocket/connect2');